import Loadable from 'react-loadable';
import LoadingSpinner from '../../LoadingSpinner';
import BlankLoader from '../../LoadingSpinner/loaderBlank';
import ConfigLoader from '../../LoadingSpinner/ConfigLoader';
import ChooseColorLoader from '../../LoadingSpinner/ChooseColorLoader';
import ChoiceWithRadioButtons from './ChoiceWithRadioButtons/index';

const CountertopDraftingToolTemplate = Loadable({
  loader: () =>
    import(/* webpackChunkName: "countertopDraftingTool" */ './countertopDraftingToolTemplate'),
  loading: LoadingSpinner,
});

const DefaultTemplate = Loadable({
  loader: () => import(/* webpackChunkName: "defaultTemplate" */ './default'),
  loading: ConfigLoader,
});

const EdgeStyleTemplate = Loadable({
  loader: () =>
    import(/* webpackChunkName: "edgeStyleTemplate" */ './defaultWithLabelsSelectFirst'),
  loading: LoadingSpinner,
});

const DefaultWithLabelsTemplate = Loadable({
  loader: () =>
    import(/* webpackChunkName: "defaultWithLabelsTemplate" */ './defaultWithLabels/index'),
  loading: ConfigLoader,
});

const HiddenTemplate = Loadable({
  loader: () => import(/* webpackChunkName: "hiddenTemplate" */ './hidden'),
  loading: BlankLoader,
});

const StepperTemplate = Loadable({
  loader: () => import(/* webpackChunkName: "stepperTemplate" */ './stepper'),
  loading: LoadingSpinner,
});

const BannerTemplate = Loadable({
  loader: () => import(/* webpackChunkName: "bannerTemplate" */ './banner'),
  loading: LoadingSpinner,
});

const SurfaceMaterialCarouselTemplate = Loadable({
  loader: () =>
    import(/* webpackChunkName: "surfaceMaterialCarousel" */ './surfaceMaterialCarousel'),
  loading: ConfigLoader,
});

const ChoiceCarouselTemplate = Loadable({
  loader: () => import(/* webpackChunkName: "choiceCarouselTemplate" */ './choiceCarousel'),
  loading: LoadingSpinner,
});

const ColorWPriceAltStyleTemplate = Loadable({
  loader: () => import(/* webpackChunkName: "colorWPriceAltStyle" */ './ColorWPriceAltStyle/index'),
  loading: ChooseColorLoader,
});

const ChoiceStepperTemplate = Loadable({
  loader: () => import(/* webpackChunkName: "choiceStepper" */ './choiceStepper'),
  loading: LoadingSpinner,
});

const RadioButtonWithCopyTemplate = Loadable({
  loader: () => import(/* webpackChunkName: "radioButtonWithCopy" */ './radioButtonWithCopy'),
  loading: LoadingSpinner,
});

const SimpleChoiceStepperTemplate = Loadable({
  loader: () => import(/* webpackChunkName: "simpleChoiceStepper" */ './simpleChoiceStepper'),
  loading: LoadingSpinner,
});

const RadioButtonWithCopyHideIfOneTemplate = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "radioButtonWithCopyHideIfOne" */ './radioButtonWithCopyHideIfOne/index'
    ),
  loading: LoadingSpinner,
});

const InfoTileTemplate = Loadable({
  loader: () => import(/* webpackChunkName: "infoTile" */ './infoTile'),
  loading: LoadingSpinner,
});

const MarkdownWithCopyTemplate = Loadable({
  loader: () => import(/* webpackChunkName: "markDownWithCopy" */ './markdownWithCopy'),
  loading: LoadingSpinner,
});

const ChoiceWithRadioButtonsTemplate = Loadable({
  loader: () => import(/* webpackChunkName: "ChoiceWithRadioButtons" */ './ChoiceWithRadioButtons'),
  loading: LoadingSpinner,
});
const DropDownWithPriceTemplate = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "dropDownWithPrice" */ './dropdownWithPrice/DropDownWithPriceTemplate'
    ),
  loading: LoadingSpinner,
});

const SqFtDecimalInputTemplate = Loadable({
  loader: () => import(/* webpackChunkName: "sqftDecimalInput" */ './sqFtDecimalInput'),
  loading: LoadingSpinner,
});

const SurfaceThicknessTemplate = Loadable({
  loader: () => import(/* webpackChunkName: "surfaceThickness" */ './surfaceThickness/index'),
  loading: LoadingSpinner,
});

const templates = {
  Default: DefaultTemplate,
  Hidden: HiddenTemplate,
  Banner: BannerTemplate,
  ChoiceCarousel: ChoiceCarouselTemplate,
  SurfaceMaterial: SurfaceMaterialCarouselTemplate,
  Stepper: StepperTemplate,
  ColorWPriceAltStyle: ColorWPriceAltStyleTemplate,
  ChoiceStepper: ChoiceStepperTemplate,
  SimpleChoiceStepper: SimpleChoiceStepperTemplate,
  RadioButtonWithCopy: RadioButtonWithCopyTemplate,
  InfoTile: InfoTileTemplate,
  RadioButtonWithCopyHideIfOne: RadioButtonWithCopyHideIfOneTemplate,
  MarkdownWithCopy: MarkdownWithCopyTemplate,
  ChoiceWithRadioButtons: ChoiceWithRadioButtonsTemplate,
  DefaultWithLabels: DefaultWithLabelsTemplate,
  EdgeStyle: EdgeStyleTemplate,
  DropdownWithPrice: DropDownWithPriceTemplate,
  SqFtDecimalInput: SqFtDecimalInputTemplate,
  SurfaceThickness: SurfaceThicknessTemplate,
  CountertopDraftingTool: CountertopDraftingToolTemplate,
};

export default templates;
